<template>
<div>
    <h2><i class="fa fa-fw fa-lg fa-image"></i> Logo</h2>
    <p></p>
    <div class="v-form-partial">
        <div class="v-form">
            <fieldset>
                    <section>
                        <div class="note">Die Breite des Logos sollte max. 250 Pixel betragen</div>
                        <label for="file" class="input input-file">
                            <div class="button">
                                <input id="upload" @change="onFileChange" type="file" accept="image/*">Auswählen
                            </div>
                            <input id="logo" type="text" placeholder="Logo auswählen" readonly>
                        </label>
                    </section>
                    <section v-if="logoPreview">
                        <img  :src="logoPreview" width="250" alt='LOGO'>
                        <br>
                        <a @click="deleteLogo" class="underline-hover pointer" id="confirm-delete-logo">Lösche Bild</a>
                    </section>
                <br>
                    <section class="<?= ($this->logoPositioningSupported ? '' : 'is-disabled' ) ?>">
                        <label class="label">Position Logo und Anschrift</label>
                        <div class="row">
                            <div class="col col-6">
                                <label class="radio state-success">
                                    <input type="radio" value="left" v-model="logo.logo_position"><i></i>
                                    <img :src="require('@/assets/img/invoice/left.png')" data-toggle="tooltip" data-placement="top" title="Logo linksbündig und Anschrift rechtsbündig">
                                </label>
                                <label class="radio state-success">
                                    <input type="radio" value="right" v-model="logo.logo_position"><i></i>
                                    <img :src="require('@/assets/img/invoice/left.address.png')" data-toggle="tooltip" data-placement="top" data-html="true" title="Logo über der Anschrift linksbündig<br>(Nicht geeignet für Fensterbriefumschläge)">
                                </label>
                            </div>
                            <div class="col col-6">
                                <label class="radio state-success">
                                    <input type="radio" value="left_top" v-model="logo.logo_position"><i></i>
                                    <img :src="require('@/assets/img/invoice/right.png')" data-toggle="tooltip" data-placement="top" title="Logo rechtsbündig und Anschrift linksbündig">
                                </label>
                                <label class="radio state-success">
                                    <input type="radio" value="right_top" v-model="logo.logo_position"><i></i>
                                    <img :src="require('@/assets/img/invoice/right.address.png')" data-toggle="tooltip" data-placement="top" data-html="true" title="Logo über der Anschrift rechtsbündig<br>(Nicht geeignet für Fensterbriefumschläge)">
                                </label>
                            </div>
                        </div>
                    </section>
                    <section class="<?= ($this->logoPositioningSupported ? 'hide' : '' ) ?>">
                        <div class="note"><b>Hinweis:</b> Das eingestellte Rechnungstemplate gibt die Positionierung des Logos fix vor.</div>
                    </section>
            </fieldset>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors.js';
import ModelActionsMixin from '@/mixins/ModelActions.js';

export default {
    props: ['operatorId', 'componentParentView'],

    mixins: [FormErrorsMixin, ModelActionsMixin],

    data() {
        return {
            validatedInputs: [
                'logo_content', 'logo_position'
            ],
            errors: [],
            parentView: this.componentParentView,
            alwaysUpdate: true,
            modelData: 'logo',
            logo: {
                logo_position: null,
                logo_content: null,
                logo_url: null,
            },
            previewImageUrl: null,
        }
    },

    mounted() {
        this.initializeBillingSetting();
    },

    methods: {
        initializeBillingSetting() {
            if (!this.operatorId) {
                return;
            }

            this.resetModel();
            this.resetLogo();
            this.getBillingSetting();
        },

        getBillingSetting(successCallback) {
            let endpoint = this.$partnerEndpoint('operators/' + this.operatorId + '/billing-setting');
            Api().get(endpoint)
                .then((response) => {
                    this.logo.logo_position = response.data.data.logo.position;
                    this.logo.logo_url = response.data.data.logo.url;
                    this.emitModelLoadedEvent();
                })
                .catch((error) => {
                    this.emitModelLoadedEvent(false);
                });
        },

        updateModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('operators/' + this.operatorId + '/billing-setting/logo');

            Api().put(endpoint, this.logo)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                    this.storeErrors(error.response.data.errors);
                });
        },

        deleteLogo() {
            //
        },

        onFileChange(e) {
            const file = e.target.files[0];
            this.previewImageUrl = URL.createObjectURL(file);

            var vm = this;
            var reader = new FileReader();

            reader.onload = function(readerEvt) {
                var binaryString = readerEvt.target.result;
                vm.logo.logo_content = btoa(binaryString);
            };

            reader.readAsBinaryString(file);
        },

        resetLogo() {
            this.previewImageUrl = null;
            this.logo.logo_position = null;
            this.logo.logo_content = null;
            this.logo.logo_url = null;
        },
    },

    computed: {
        logoPreview() {
            if (this.previewImageUrl) {
                return this.previewImageUrl;
            }

            return this.logo.logo_url;
        },
    },

    watch: {
        operatorId(operatorId) {
            this.initializeBillingSetting();
        },
    },
}
</script>
